import { useTranslations } from 'next-intl'

export enum TabValue {
  ROOM_INFORMATION = 'room-information',
  CONTRACT_INFORMATION = 'contract-information',
  REVIEW = 'review',
  HOST_INFORMATION = 'host-information',
}

export const getTabOptions = (
  t: ReturnType<typeof useTranslations<'room_detail'>>,
) => {
  const TABS = [
    {
      label: t('tab.unit_detail'),
      value: TabValue.ROOM_INFORMATION,
    },
    {
      label: t('tab.lease'),
      value: TabValue.CONTRACT_INFORMATION,
    },
    {
      label: t('tab.review'),
      value: TabValue.REVIEW,
    },
    {
      label: t('tab.landlord'),
      value: TabValue.HOST_INFORMATION,
    },
  ]

  const CONTRACT_ROOM_TABS = [
    {
      label: t('tab.unit_detail'),
      value: TabValue.ROOM_INFORMATION,
    },
    {
      label: t('tab.lease'),
      value: TabValue.CONTRACT_INFORMATION,
    },
  ]

  return {
    TABS,
    CONTRACT_ROOM_TABS,
  }
}
